import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urls from '../utilities/urls';
import { AttachmentSearch } from '../models/attachments';
import { NzTableData } from './nz-table.adapter';
import {SettlementDocumentStatus, textForSettlementDocumentStatus, KycStatus, KycStatusText,
TransactionAccountTypes, TransactionAccountTypesText, UsersTypeText,
UsersType, emptyFields, Tier, TierName, SettlementStatus, settlementStatusText,
TagColorForTransactionAccountType, tagColorForsettlementDocumentStatus, tagColorForSettlementStatus, SettlementFrequency, SettlementFrequencyStatusText,PaymentMethod,PaymentMethodText,PaymentMethodColor,SettlementBy, SettlementByText,SettlementByColor, currencyForAppCode, currencyForALLAppcode, AvailableColor, availableStatus, availableStatusText, tagColorForAvailableStatus,UserTypeColor, UserTypeText, UserTypes, StatusTextColor, Status, UserStatus, UserStatusText, MerchantOrderStatus, MerchantOrderStatusColor, MerchantOrderStatusText, tagColorForPaymentModes, PaymentModeText, AssignedColor, MerchantPaymentStatus, MerchantPaymentStatusColor, MerchantPaymentText, voucherType, voucherTypeText, voucherTypeColor, purchaseType, purchaseTypeText, purchaseTypeColor, DeliveryMethod, VoucherStatus, voucherStatusColor, voucherStatusText, voucherCodeStatus, voucherCodeStatusColor, voucherStatusCodeText} from '../utilities/common-file';
import { countries } from './countries';
import { CommentSearch } from '../models/comments';
import { Config } from 'src/environments/config';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private httpClient: HttpClient) {}
  countries = countries;

  getUserType(type) {
    // tslint:disable-next-line: no-shadowed-variable
    const key = Object.keys(UsersType).find( key => UsersType[key] === type);
    return UsersTypeText[key] ? UsersTypeText[key] : emptyFields.NA;
  }
  getTransactionAccountType(type) {
    const key = Object.keys(TransactionAccountTypes).find( key => TransactionAccountTypes[key] === type);
    return TransactionAccountTypesText[key] ? TransactionAccountTypesText[key] : emptyFields.NA;
  }
  getKycStatus(status: string) {
    const key = Object.keys(KycStatus).find( key => KycStatus[key] === status);
    return KycStatusText[key] ? KycStatusText[key] : emptyFields.NA;
  }
  getTier(tier) {
    const key = Object.keys(Tier).find( key => Tier[key] === tier);
    return TierName[key] ? TierName[key] : emptyFields.NA;
  }
  getTransactionAccountTypeWithExternalPayment(value) {
    if (value === '' || value === null) {
      return '';
    } else if (value === TransactionAccountTypes.qrPayment) {
      return [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment];
    } else if (value === TransactionAccountTypes.settlement || value === TransactionAccountTypes.refund || value === TransactionAccountTypes['MONTHLY-TRANSFER-FEE']) {
      return [value];
    } else if (value) {
      return value;
    }
  }
  getSettlementDocumentStatus(status) {
    const key = Object.keys(SettlementDocumentStatus).find(key => SettlementDocumentStatus[key] === status);
    return textForSettlementDocumentStatus[key] ? textForSettlementDocumentStatus[key] : emptyFields.NA;
  }
  getSettlementStatus(status) {
    const key = Object.keys(SettlementStatus).find(key => SettlementStatus[key] === status);
    return settlementStatusText[key];
  }
  getColorForTransactionAccountType(type) {
    const key = Object.keys(TransactionAccountTypes).find(key => TransactionAccountTypes[key] === type);
    return TagColorForTransactionAccountType[key] ? TagColorForTransactionAccountType[key] : '';
  }
  getAvailableColor(key){
   return AvailableColor[key] ? AvailableColor[key]:'';
  }
  getAssignedColor(key){
    return AssignedColor[key] ? AssignedColor[key] : '';
  }
  getStatus(type) {
    const key = Object.keys(UserStatus).find(key => UserStatus[key] === type);
    return UserStatusText[key] ? UserStatusText[key] : emptyFields.NA;
  }
  getStatusText(key){;
     return Status[key]?Status[key]:'';
  }
  getStatusColor(key){
     return StatusTextColor[key] ? StatusTextColor[key] : '';
  }
  getColorForSettlementDocumentStatus(status) {
    const key = Object.keys(SettlementDocumentStatus).find(key => SettlementDocumentStatus[key] === status);
    return tagColorForsettlementDocumentStatus[key] ? tagColorForsettlementDocumentStatus[key] : '';
  }

  getColorForSettlementStatus(status) {
    const key = Object.keys(SettlementStatus).find(key => SettlementStatus[key] === status);
    return tagColorForSettlementStatus[key] ? tagColorForSettlementStatus[key] : '';
  }
  getSettlementFrequencyStatus(status) {
    const key = Object.keys(SettlementFrequency).find((key) => SettlementFrequency[key] === status);
    return SettlementFrequencyStatusText[key] ? SettlementFrequencyStatusText[key] : SettlementFrequencyStatusText.off;
  }
  getMrechantPaymentTypeStatus(type) {
    const key = Object.keys(MerchantPaymentStatus).find(key => MerchantPaymentStatus[key] === type);
    return MerchantPaymentText[key] ? MerchantPaymentText[key] : emptyFields.NA;
  }
  getColorForMerchantPayment(status){
    const key = Object.keys(MerchantPaymentStatus).find((key) => MerchantPaymentStatus[key] === status);
    return MerchantPaymentStatusColor[key] ? MerchantPaymentStatusColor[key] : '';
  }
  getCurrency(currency) {
    const index = this.countries.findIndex(M => M.currency_code ===  currency);
    if (index !== -1) {
        return this.countries[index].currency_symbol;
    }
}
  // Attachments
  uploadAttachments(id, value) {
    return this.httpClient.post(urls.AttachmentUrls.uploadAttachments + id , value);
  }
  //new Attachment method
  uploadAttachmentsNew(value) {
    return this.httpClient.post(urls.AttachmentUrls.uploadAttachments, value);
  }
  downloadAttachments(id, fileName) {
    return this.httpClient.get(urls.AttachmentUrls.downloadAttachments + id +
    '/' + fileName,  { responseType: 'blob' as 'json'});
  }
  listAttachments(tableData: NzTableData<AttachmentSearch, any>) {
    const value = {
      referenceId: tableData.search.id,
      code: tableData.search.code,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
  };
    return this.httpClient.post(urls.AttachmentUrls.listAttachments , value);
  }
  deleteAttachment(id) {
    return this.httpClient.delete(urls.AttachmentUrls.deleteAttachments + id);
  }
  // Comments
createComments(value) {
  return this.httpClient.post(urls.CommentsUrls.commentsCreate, value);
}
getCommentsWithLimit(tableData: NzTableData<CommentSearch, any>) {
  const value = {
      type: tableData.search.type,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      referenceId: tableData.search.referenceId
  };
  return this.httpClient.post(urls.CommentsUrls.commentsList, value);
}
// PaymentMethod
getPaymentMethod(type) {
  const key = Object.keys(PaymentMethod).find( key => PaymentMethod[key] === type);
  return PaymentMethodText[key] ? PaymentMethodText[key] : emptyFields.NA;
}
// PaymentMethodColor
getColorForPaymentMethod(type) {
  const key = Object.keys(PaymentMethod).find(key => PaymentMethod[key] === type);
  return PaymentMethodColor[key] ? PaymentMethodColor[key] : '';
}
// SettlementBy
getSettlementBy(type) {
  const key = Object.keys(SettlementBy).find( key => SettlementBy[key] === type);
  return SettlementByText[key] ? SettlementByText[key] : emptyFields.NA;
}
// SettlementByColor
getColorForSettlementBy(type) {
  const key = Object.keys(SettlementBy).find(key => SettlementBy[key] === type);
  return SettlementByColor[key] ? SettlementByColor[key] : '';
}
//Method to return currency symbol based on the appcode 
getCurrencySymbol(appCode){
  return appCode ? currencyForAppCode.find(m => m.appCode === appCode).symbol : currencyForALLAppcode.find(m=>m.instance === Config.appCode).symbol;
 }
 //Method to return currency based on merchantCurrency
 getMerchantCurrency(data){
  return data ? currencyForAppCode.find(m => m.currency === data).symbol : '';
 }
//  Available Status By Text
 getAvailableStatus(status) {
  const key = Object.keys(availableStatus).find(key => availableStatus[key] === status);
  return availableStatusText[key] ? availableStatusText[key] : emptyFields.NA;
}
//  Payment Status By Text
getPaymentStatus(status) {
   return PaymentModeText[status] ? PaymentModeText[status] : emptyFields.NA;
}
//  Available Status By Color
getColorForAvailableStatus(status) {
  const key = Object.keys(availableStatus).find(key => availableStatus[key] === status);
  return tagColorForAvailableStatus[key] ? tagColorForAvailableStatus[key] : '';
}
getColorForPaymentStatus(status) {
  //const key = Object.keys(PaymentModeText).find(key => PaymentModeText[key] === status);
  return tagColorForPaymentModes[status] ? tagColorForPaymentModes[status] : '';
}
getUsersType(type) {
  const key = Object.keys(UserTypes).find(key => UserTypes[key] === type);
  return UserTypeText[key] ? UserTypeText[key] : emptyFields.NA;
}
getUsersTypeColor(type) {
  const key = Object.keys(UserTypes).find(key => UserTypes[key] === type);
  return UserTypeColor[key] ? UserTypeColor[key] : '';
}
getOrderStatus(status: string) {
  const key = Object.keys(MerchantOrderStatus).find( key => MerchantOrderStatus[key] === status);
  return MerchantOrderStatusText[key] ? MerchantOrderStatusText[key] : emptyFields.NA;
}
getOrderStatusColor(status: string) {
  const key = Object.keys(MerchantOrderStatus).find((key) => MerchantOrderStatus[key] === status);
 return MerchantOrderStatusColor[key] ? MerchantOrderStatusColor[key] : '';
}
getDeliveryMethod(key:string){
  return DeliveryMethod[key]?DeliveryMethod[key]:emptyFields.NA;
}
getVoucherType(type) {
  const key = Object.keys(voucherType).find(key => voucherType[key] === type);
  return voucherTypeText[key] ? voucherTypeText[key] : emptyFields.NA;
}
getVoucherTypeColor(type) {
  const key = Object.keys(voucherType).find(key => voucherType[key] === type);
  return voucherTypeColor[key] ? voucherTypeColor[key] : '';
}
getVoucherPurchaseType(type) {
  const key = Object.keys(purchaseType).find(key => purchaseType[key] === type);
  return purchaseTypeText[key] ? purchaseTypeText[key] : emptyFields.NA;
}
getVoucherPurchaseTypeColor(type) {
  const key = Object.keys(purchaseType).find(key => purchaseType[key] === type);
  return purchaseTypeColor[key] ? purchaseTypeColor[key] : '';
}
getVoucherStatus(type) {
  const key = Object.keys(VoucherStatus).find(key => VoucherStatus[key] === type);
  return voucherStatusText[key] ? voucherStatusText[key] : emptyFields.NA;
}
getVoucherStatusColor(type) {
  const key = Object.keys(VoucherStatus).find(key => VoucherStatus[key] === type);
  return voucherStatusColor[key] ? voucherStatusColor[key] : '';
}
getvoucherCodeStatus(type) {
  const key = Object.keys(voucherCodeStatus).find(key => voucherCodeStatus[key] === type);
  return voucherStatusCodeText[key] ? voucherStatusCodeText[key] : emptyFields.NA;
}
getVoucherCodeStatusColor(type) {
  const key = Object.keys(voucherCodeStatus).find(key => voucherCodeStatus[key] === type);
  return voucherCodeStatusColor[key] ? voucherCodeStatusColor[key] : '';
}
}
